import { render, staticRenderFns } from "./SoundIcon.vue?vue&type=template&id=3bc9da84&scoped=true&"
import script from "./SoundIcon.vue?vue&type=script&lang=js&"
export * from "./SoundIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9da84",
  null
  
)

export default component.exports